import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

export default function FactoryIdentityQr({ url }: { url: string }) {
  const matrix = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(url, 'Byte');
    qr.make();
    const size = qr.getModuleCount();
    const modules: string[] = [];
    for (let row = 0; row < size; row++) {
      for (let col = 0; col < size; col++) {
        if (qr.isDark(row, col)) modules.push(`M${col + 4} ${row + 4}h1v1h-1z`);
      }
    }
    return { size: size + 8, path: modules.join('') };
  }, [url]);
  return <svg role="img" aria-label="支付宝实名认证二维码" viewBox={`0 0 ${matrix.size} ${matrix.size}`} shapeRendering="crispEdges"><rect width="100%" height="100%" fill="#fff" /><path d={matrix.path} fill="#000" /></svg>;
}
